import { render, staticRenderFns } from "./comanda.vue?vue&type=template&id=70a001d1&scoped=true"
import script from "./comanda.vue?vue&type=script&lang=js"
export * from "./comanda.vue?vue&type=script&lang=js"
import style0 from "./comanda.vue?vue&type=style&index=0&id=70a001d1&prod&lang=scss"
import style1 from "./comanda.vue?vue&type=style&index=1&id=70a001d1&prod&scoped=true&lang=css"
import style2 from "./comanda.vue?vue&type=style&index=2&id=70a001d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a001d1",
  null
  
)

export default component.exports